'use client';

import { Button } from '@savvy-kit/components/button';
import { Dialog, DialogContent, DialogTitle } from '@savvy-kit/components/dialog';

type TaxBulkEditDialogProps = {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly onConfirm: () => void;
  readonly eligibleClientCount: number;
  readonly totalSelectedCount: number;
  readonly loading?: boolean;
};

export function TaxBulkEditDialog({
  open,
  onClose,
  onConfirm,
  eligibleClientCount,
  totalSelectedCount,
  loading = false,
}: TaxBulkEditDialogProps) {
  const ineligibleCount = totalSelectedCount - eligibleClientCount;
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <DialogTitle>
          <h1 className="text-lg font-semibold">Mark not interested</h1>
        </DialogTitle>
        <div className="flex flex-col gap-2">
          {ineligibleCount > 0 && (
            <p>
              You selected {totalSelectedCount} clients but {ineligibleCount} are already enrolled and will not be
              marked as “not interested”.
            </p>
          )}
          <p>A total of {eligibleClientCount} clients will be marked as “not interested”.</p>
          <div className="flex justify-end pt-2 gap-2">
            <Button variant="outline" onClick={onClose} disabled={loading}>
              Cancel
            </Button>
            <Button onClick={onConfirm} disabled={loading}>
              {loading ? 'Processing...' : 'Confirm'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
